import React from "react";
import { FacebookIcon, InstagramIcon } from "lucide-react";
import { Logo } from "./Logo";
import { navItems } from "../data/navigation";
import { needs } from "../data/needs";
export function Footer() {
  return <footer className="w-full bg-ink text-white" data-id="element-35" data-mp="32ovvqqc38li1">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:px-10" data-id="element-36" data-mp="32m1ef7odfgsu">
        <div className="grid gap-12 md:grid-cols-12" data-id="element-37" data-mp="36pzaf9iegbho">
          <div className="md:col-span-5" data-id="element-38" data-mp="3ufa6wespvjq0">
            <Logo inverted data-id="element-39" data-mp="3ufjww2drhqvp" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60" data-id="element-40" data-mp="3ud7gvurkdqla">
              Cabinet de gestion de patrimoine à Paris. Des solutions financières et fiscales adaptées à votre
              situation.
            </p>
            <div className="mt-6 flex gap-2" data-id="element-41" data-mp="3qcx9cdo4is4b">
              <a href="#" aria-label="Instagram" className="rounded-full border border-white/15 p-2.5 text-white/70 transition-colors duration-150 hover:text-white" data-id="element-42" data-mp="3qblxdqkiye24">
                <InstagramIcon className="h-4 w-4" data-id="element-43" data-mp="2ezbb830adg6n" />
              </a>
              <a href="#" aria-label="Facebook" className="rounded-full border border-white/15 p-2.5 text-white/70 transition-colors duration-150 hover:text-white" data-id="element-44" data-mp="3l9adfilcf44f">
                <FacebookIcon className="h-4 w-4" data-id="element-45" data-mp="3gcjywzp6sgl4" />
              </a>
            </div>
          </div>
          <nav aria-label="Pied de page" className="md:col-span-3" data-id="element-46" data-mp="3v5n56axbv7wj">
            <h2 className="text-sm font-semibold" data-id="element-47" data-mp="3q7u23qrbmu0h">Le cabinet</h2>
            <ul className="mt-4 space-y-3" data-id="element-48" data-mp="82qp7jv45dpi">
              {navItems.map(item => <li key={item.label} data-id="element-49" data-mp="33xchtnnhqqe">
                  <a href={item.href} className="text-sm text-white/60 transition-colors duration-150 hover:text-white" data-id="element-50" data-mp="32w3rvu3xgbu">
                    {item.label}
                  </a>
                </li>)}
            </ul>
          </nav>
          <div className="md:col-span-4" data-id="element-51" data-mp="cw33p162w44j">
            <h2 className="text-sm font-semibold" data-id="element-52" data-mp="qsqeo7uv8utg">Vos besoins</h2>
            <ul className="mt-4 space-y-3" data-id="element-53" data-mp="mrwplb5ot9yz">
              {needs.map(n => <li key={n.id} data-id="element-54" data-mp="mptq80ina4hl">
                  <a href="#besoins" className="text-sm text-white/60 transition-colors duration-150 hover:text-white" data-id="element-55" data-mp="tvczxt1gc7fo">
                    {n.title}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-white/50 md:flex-row md:items-center md:justify-between" data-id="element-56" data-mp="13rzj8de4qqfl">
          <p data-id="element-57" data-mp="1cm448g6l17n7">© {new Date().getFullYear()} Success Capital — Conseil en investissement. Tous droits réservés.</p>
          <ul className="flex gap-6" data-id="element-58" data-mp="1hjw7258rme66">
            <li data-id="element-59" data-mp="1hiulv7y1cbaq"><a href="#" className="hover:text-white" data-id="element-60" data-mp="1hms65wwcn8w7">Mentions légales</a></li>
            <li data-id="element-61" data-mp="1ml3chxnfr19o"><a href="#" className="hover:text-white" data-id="element-62" data-mp="1mkbkewt1rlo5">Politique de confidentialité</a></li>
            <li data-id="element-63" data-mp="1rhk4x41o41sk"><a href="#" className="hover:text-white" data-id="element-64" data-mp="1rhk08qqq3dm8">Réclamations</a></li>
          </ul>
        </div>
      </div>
    </footer>;
}